"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BottomButtons;
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const React = __importStar(require("react"));
require("./bottom-buttons.scss");
function BottomButtons(props) {
    const { submitting, onCancel, onSubmit, id, disabled } = props;
    const isDisabled = disabled || submitting;
    return (React.createElement("div", { id: id, className: "footer-actions", "data-testid": "bottom-buttons" },
        React.createElement(teamsnap_ui_1.Button, { isDisabled: isDisabled, mods: "cancel", icon: "dismiss", onClick: onCancel }, "Cancel"),
        React.createElement(teamsnap_ui_1.Button, { type: "submit", isDisabled: isDisabled, color: "primary", icon: submitting ? null : 'check', onClick: onSubmit },
            submitting && React.createElement(teamsnap_ui_1.Loader, { type: "spin", style: { width: '13px', height: '13px' } }),
            'Save')));
}
